import utils from 'utils'
import { parseOfdDocument, renderOfd } from '../../../../../vendor/ofd/ofd'

class inputDetailCtrl {
    constructor($scope, httpRequest, globalFn, logger, $stateParams, hasPDFReader) {
        console.log($stateParams)
        $scope.invType = $stateParams.invType
        // 隐藏一二级菜单
        if ($stateParams.detailFlag === true) {
            $('#wrapper').addClass('invoiceDetailPage')
            $scope.$on('$stateChangeStart', () => {
                $('#wrapper').removeClass('invoiceDetailPage')
            })
        }
        const types = ['preferential_code']
        httpRequest.get_dictByTypeArr(types).then((res) => {
            $scope.dictData = res.data.value
        })
        let data = {
            invoiceId:$stateParams.invoiceId,
            needAdditional:false,
            needDetail:true,
            needExtend:true,
        }
        // httpRequest.get_selectBillDetailById($stateParams.invoiceId).then((res) => {

        // })
        httpRequest.post_ivatGetPool(data).then((res) => {
            $scope.invoice = res.data.value.invoicePool
            $scope.detailItemList = res.data.value.detailList
            $scope.flightDataList = res.data.value.flightList
            $scope.invoiceExtend = res.data.value.invoicePoolExtend
            $scope.detailChineseTotal = globalFn.digitUppercase($scope.invoice.adValoremTotal)
            if ($scope.invoice.invType == '41' || $scope.invoice.invType == '12' ) $scope.codeVersions = $scope.detailItemList[0].revenueVersion
            if($scope.invoice.invType =='66'|| $scope.invoice.invType =='67'){
                $scope.invoice.passwordArea = '数电票号码：' + $scope.invoice.electricInvoiceNum + '\n' + '全国增值税发票查验平台：'+ '\n' + 'https://inv-veri.chinatax.gov.cn/'
            }
            $scope.fileInfo = res.data.value.fileInfo
            $scope.fileUrl = res.data.value.fileUrl

            $scope.ispdf = false // 票据影像类型PDF
            $scope.isofd = false // 票据影像类型OFD
            $scope.noimg = false // 无票据影像类型

            if ($scope.fileInfo && $scope.fileInfo.fileType == 'pdf') {
                $scope.ispdf = true
                if (hasPDFReader()) $scope.canShowPDF = true
            }
            if ($scope.fileInfo && $scope.fileInfo.fileType == 'ofd') {
                $scope.isofd = true
                let file = null
                $scope.getFileFromUrl($scope.fileUrl,$scope.fileInfo.fileName)
                    .then((response)=>{
                        file = response
                        $scope.getOfdDocumentObj(response, document.body.clientWidth);
                    })
                    .catch((e)=>{
                        console.error(e)
                    });

            }
            const imagKey = $scope.fileInfo ? $scope.fileInfo.storageKey : ''
            if ($scope.fileInfo) {
                $scope.imgSrc = `${host.etcloudIvatApp}common/common/getFile?fileKey=${imagKey}`
            } else {
                $scope.noimg = true
                $scope.imgSrc = ''
            }

        })

        //url转为files文件流
        $scope.getFileFromUrl = function (url, fileName){
            return new Promise((resolve, reject) => {
                var blob = null;
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url);
                xhr.setRequestHeader('Accept', 'application/ofd');
                xhr.responseType = "blob";
                // 加载时处理
                xhr.onload = () => {
                    // 获取返回结果
                    blob = xhr.response;
                    let file= new File([blob], fileName, { type: 'application/ofd' });
                    // 返回结果
                    resolve(file);
                };
                xhr.onerror = (e) => {
                    reject(e)
                };
                // 发送
                xhr.send();
            });
        }
        //调用ofdJS绘制 文件格式为OFD的发票
        $scope.getOfdDocumentObj = function (file, screenWidth){
            parseOfdDocument({
                ofd: file,
                success(res) {
                    const divs = renderOfd(screenWidth, res[0]);
                    $scope.displayOfdDiv(divs);
                },
                fail(error) {
                    console.log(error)
                }
            });
        }
        $scope.displayOfdDiv = function (divs) {
            let contentDiv = document.getElementById('content');
            contentDiv.innerHTML = '';
            for (const div of divs) {
                contentDiv.appendChild(div)
            }
        }
    }
}

inputDetailCtrl.$inject = ['$scope', 'httpRequest', 'globalFn', 'logger', '$stateParams', 'hasPDFReader']
export default inputDetailCtrl



// WEBPACK FOOTER //
// ./src/app/input/invoicePool/inputInvoicePool/detailCtrl.js